if (!customElements.get('product-gallery-dots')) {
  customElements.define(
    'product-gallery-dots',
    class ProductGalleryDots extends HTMLElement {
      constructor() {
        super();

        this.slider = document.getElementById(this.dataset.sliderId);
        this.list = this.slider?.querySelector('[id^="Slider-"]');
        this.track = this.querySelector('.product-gallery-progress__track');
        this.thumb = this.querySelector('.product-gallery-progress__thumb');
        this.slideCount = Number(this.dataset.slideCount || 1);

        if (!this.slider || !this.list || !this.track || !this.thumb || this.slideCount < 2) return;

        this.thumb.style.width = `${100 / this.slideCount}%`;

        this.onScrollHandler = this.onScroll.bind(this);
        this.list.addEventListener('scroll', this.onScrollHandler, { passive: true });
        this.onScroll();
      }

      onScroll() {
        this.reveal();

        const maxScroll = this.list.scrollWidth - this.list.clientWidth;
        const progress = maxScroll > 0 ? this.list.scrollLeft / maxScroll : 0;
        const maxTranslate = Math.max(this.track.clientWidth - this.thumb.clientWidth, 0);
        this.thumb.style.transform = `translateX(${progress * maxTranslate}px)`;
      }

      reveal() {
        this.classList.add('product-gallery-dots--visible');
      }
    }
  );
}
